import VideoFeedContainer from './video-feed-container';

export default VideoFeedContainer;
